import * as React from 'react';

import * as styles from './index.css';

export interface IZoomControlsProps {
  onZoomIn(): void;
  onZoomOut(): void;
}

export const ZoomControls = (props: IZoomControlsProps) => (
  <div className={styles['container']}>
    <div className={styles['zoom-button']} onClick={props.onZoomIn}>
      <div className={styles['in-icon']} />
    </div>
    <div className={styles['zoom-button']} onClick={props.onZoomOut}>
      <div className={styles['out-icon']} />
    </div>
  </div>
);
